<template>
  <b-card>
    <b-card-body class="p-0">
      <b-row align-h="end">
        <b-col cols="2"
          ><b-badge :variant="is_connected ? 'success' : 'danger'">{{
            is_connected ? "Connected" : "Disconnected"
          }}</b-badge></b-col
        >
      </b-row>

      <b-form>
        <b-form-group
          id="group-realmId"
          label="Quickbook Realm ID"
          label-for="realmId"
        >
          <b-form-input
            id="realmId"
            :readonly="is_connected || !has_established"
            v-model="form.realmId"
            trim
          ></b-form-input>
        </b-form-group>
        <b-button
          class="px-3 mx-2"
          size="fw"
          variant="primary"
          @click="submitForm(commands.authUri)"
          :disabled="is_connected || loadingId == commands.authUri"
        >
          <b-spinner v-if="loadingId == commands.authUri" small></b-spinner>
          Initialize
        </b-button>
        <b-button
          class="px-3 mx-2"
          size="fw"
          variant="secondary"
          @click="submitForm(commands.getRealm)"
          :disabled="
            !has_established || is_connected || loadingId == commands.getRealm
          "
        >
          <b-spinner v-if="loadingId == commands.getRealm" small></b-spinner>
          Establish
        </b-button>

        <b-button
          class="px-3 mx-2"
          size="fw"
          variant="danger"
          @click="submitForm(commands.disconnect)"
          :disabled="loadingId == commands.disconnect"
          v-if="is_connected"
        >
          <b-spinner v-if="loadingId == commands.disconnect" small></b-spinner>
          Disconnect
        </b-button>

        <b-button
          class="px-3 mx-2"
          size="fw"
          variant="success"
          @click="submitForm(commands.getCompanyInfo)"
          :disabled="loadingId == commands.getCompanyInfo"
          v-if="is_connected"
        >
          <b-spinner
            v-if="loadingId == commands.getCompanyInfo"
            small
          ></b-spinner>
          Get Info
        </b-button>
      </b-form>
      <div class="mt-6">
        <h6>{{ dataTitle }}</h6>
        <pre v-html="htmldata"></pre>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dataTitle: "",
      htmldata: "",
      token: null,
      has_established: false,    
      form: {
        realmId: null,
      },
    };
  },

  computed: {
    ...mapState("quickbook", [
      "loadingId",
      "commands",
      "authUri_data",
      "callback_data",
      "getRealm_data",
      "refreshAccessToken_data",
      "getInvoiceByNumber_data",
      "getDueInvoices_data",
      "getInvoicesByUpdateRange_data",
      "createInvoice_data",
      "getCompanyInfo_data",
      "disconnect_data",
    ]),
    quickbookRealmIdKey() {
      return this.$store.state.company.settingKeys.quickbookRealmIdKey;
    },
    configurations() {
      return this.$store.getters["company/configurations"];
    },
    is_connected() {
      return !!this.token;
    },
  },

  watch: {
    getInvoicesByUpdateRange_data: function (val) {
      const json = JSON.parse(val);
      console.log("bingo8:", json);
      const { QueryResponse } = JSON.parse(json);
      console.log("QueryResponse:", QueryResponse);
      this.htmldata = JSON.stringify(QueryResponse, null, 4);
      this.dataTitle = "Invoices Last 30 days";
    },
    getCompanyInfo_data: function (val) {
      const json = JSON.parse(val);
      console.log("bingo4:", json);
      const { CompanyInfo } = JSON.parse(json);
      console.log("CompanyInfo:", CompanyInfo);
      this.htmldata = JSON.stringify(CompanyInfo, null, 4);
      this.dataTitle = "Company Info";
    },
    disconnect_data: function () {
      this.token = null;
      this.has_established = false;
    },
    getRealm_data: function (val) {
      console.log("bingo:", val);
      if (!val) return;
      const json = JSON.parse(val);
      console.log("bingo2:", json);
      const { realmId, host, token } = JSON.parse(json);
      console.log("bingo3:", { realmId, host, token });
      this.token = token;
      this.form.realmId = realmId;
    },
    authUri_data: function (url) {
      if (!url) return;
      console.log("authUri", url);
      // Launch Popup using the JS window Object
      const left = (screen.width - 800) / 2;
      const top = (screen.height - 800) / 2;
      const parameters = `location=1,width=800,height=800,left=${left},top=${top}`;

      url = this.parseUrl(url);

      this.$store.commit(`quickbook/set_authUri`, null);
      const win = window.open(url, "_blank", parameters);
      const pollOAuth = window.setInterval(function () {
        try {
          if (win.document.URL.indexOf("code") >= 0) {
            window.clearInterval(pollOAuth);
            win.close();
            location.reload();
          }
        } catch (e) {
          /// console.log(e)
        }
      }, 100);
      this.has_established = true;
    },
   /*  configurations: {
      handler: function (_configurations) {
        this.setconfigurations(_configurations);
      },
      deep: true,
    },
    first_checked: function (val) {
      console.log("first checked:", val);
    }, */
  },

  created() {
    (async () => {
      await this.$store.dispatch(
        "company/fetchConfiguration",
        this.quickbookRealmIdKey
      );

      const key = this.quickbookRealmIdKey;

      this.$nextTick(() => {
        const setting = (this.configurations || []).find((x) => x.key === key);
        this.form.realmId = setting.text_value;
        if (this.form.realmId) {
          this.submitForm(this.commands.getRealm);
        }
      });
    })();
  },
  mounted() {
    ////this.setconfigurations(this.configurations, true);
  },

  methods: {
    updateSettings() {
      const key = this.quickbookRealmIdKey;
      const text_value = this.form.realmId;
      const bool_value = false;
      const obj = { key, text_value, bool_value };
      this.$store.dispatch("company/updateConfiguration", obj);
    },

   /*  setconfigurations(_configurations, shouldfetch = false) {
      const { first_checked, form } = this;
      const key = this.quickbookRealmIdKey;
      const setting = (_configurations || []).find((x) => x.key === key);

      if (first_checked)
        this.$nextTick(() => {
          this.form.realmId = setting.text_value;
          if (this.form.realmId && shouldfetch) {
            this.submitForm(this.commands.getRealm);
          }
        });
    }, */

    parseUrl(url) {
      const httpsAppend = "https://";
      return `${httpsAppend}${url.slice(httpsAppend.length)}`;
    },

    submitForm(cmd) {
      this.dataTitle = "";
      this.htmldata = "";
      const ams_request = { ...this.form };
      if (cmd == this.commands.getRealm) {
        if (!this.form.realmId) {
          return;
        }
        this.updateSettings();
      }
      if (cmd == this.commands.getInvoicesByUpdateRange) {
        const thrityDays = 30 * 24 * 3600 * 1000 * 6;
        ams_request.endDateTime = new Date(Date.now()).toISOString();
        ams_request.startDateTime = new Date(
          Date.now() - thrityDays
        ).toISOString();
      }
      this.$store.dispatch("quickbook/queryQuickbook", {
        ams_request,
        cmd,
      });
    },
  },
};
</script>
